var screen_xs = 480
var screen_sm = 768
var screen_md = 992
var screen_lg = 1200

$(document).ready(function() {
  // products slider navigation color inverse
  $('.js-slider-arrow').hover(function() {
    $(this).find('i').removeClass('fa-inverse')
  },function() {
      $(this).find('i').addClass('fa-inverse')
    }
  )
  // color variants background colors
  allVariants = $('.js-product-variant-option')

  allVariants.each(function(){
    if($(this).data('type') == 'Color') {
      color = $(this).find('label')[0].innerText.toLowerCase()
      $(this).css('background', color).css('color', color)
    }
  })

  // slightly size up color boxes if hovered
  colorBoxes = $('.js-product-variant-option[data-type="Color"]')

  colorBoxes.click(function() {
    colorBoxes.each(function() {
      $(this).find('div').removeClass('corner-triangle')
    })
    $(this).find('div').addClass('corner-triangle')
  })

  // proper variant 
  $(document).on('click', '.js-product-variant-option', function() {
    var variantOptions = $($(this).parent('.variant-options').find('input:checked'))[0]
    $(this).parent('.variant-options').find('input:checked').prop("checked", false)
    var inputToSearch = $(this).data("var")
    var toCheck = $(`input[value='${inputToSearch}']`)
    toCheck.prop("checked", true)    
    
    var name = variantOptions.name
    var value = $(this).find('label')[0].innerText
    var variantId

    if( $(this).data('type') != 'Size' ) {
      value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()  

      var inputs = $("input").filter(function() { return $(this).data("type") == "Size" })
      inputs = inputs.filter( function() { return $(this).prop("checked") } )
      variantId = $(`option:contains('${inputs[0].value + " / " + value}')`)[0].value
    } else {
      var inputs = $("input").filter(function() { return $(this).data("type") == "Color" })
      inputs = inputs.filter( function() { return $(this).prop("checked") } )
      variantId = $(`option:contains('${this.innerText + " / " + inputs[0].value}')`)[0].value 
    }

    var select = $(`#${name}`)
    select.val(value).change()
    $('.js-id-select').val(variantId).change()
                      .data("data-product-set", variantId)
  })

  $(document).on('click', '.js-quick-view-checkout', function() {
    if( $('.js-single-id-select')) {
      $('.js-single-id-select').val($('.js-single-id-select').data('product').set)
    }
  })

  // hide or show featured image on left
  if(window.innerWidth < 996) {
    $('.js-disp-none').addClass('disp-block')
                      .removeClass('disp-none')

    $('.js-disp-block').addClass('disp-none')
                       .removeClass('disp-block')
  } 

  // product tile animation
  $('.js-product-set-layer').hover(function() {
      $(this).removeClass('start-product-set-layer')
      $('.js-anim-down').addClass('anim-down anim-up')
    }
  )

  // progressbar
  var line = new ProgressBar.Line('.js-progressbar-container')
  line.animate(1, function() {
    line.destroy()
  })

  //quick cart plus and minus
  $(document).on('click', '.js-quantity-number button', function() {
    var newValue = 0;
    switch($(this).data('type')) {
      case('plus'):
        var inputToChange = $(this).parent().siblings('input')
        var inputValue = parseInt(inputToChange.val())
        newValue = inputValue + 1
        $(inputToChange).val(newValue)
        changeQuantityOfCartProduct( newValue ,$(this).parents('.quick-cart-item').find('.js-remove-link') )
        break
      case('minus'):
        var inputToChange = $(this).parent().siblings('input')
        var inputValue = parseInt(inputToChange.val())
        if(inputValue > 0) {
          newValue = inputValue - 1
          $(inputToChange).val(newValue)
        } 

        if($(this).parent().siblings('input').val() == 0) {
          removeFromCart( $(this).parents('.quick-cart-item').find('.js-remove-link') )
        } else {
          changeQuantityOfCartProduct( newValue ,$(this).parents('.quick-cart-item').find('.js-remove-link') )
        }
        break
    }
  })

  //quick cart visibility issue
  $(document).on('mouseover', '.js-navbar-cart-icon', function() {
    $('.js-quick-cart').removeClass('quick-cart-animate-back')
                    .css("visibility", "visible")
                    .addClass('quick-cart-animate')
  })

  // quick cart animate
  $(document).on('mouseleave', '.js-navbar-cart-icon', function() {
    $('.js-quick-cart').addClass('quick-cart-animate-back')
                    .removeClass('quick-cart-animate') 
  })

  $(document).on('click', '.js-quick-cart-mobile', function(e) {
    e.preventDefault()
    if($('.js-quick-cart').is(':visible')) { 
      $('.js-quick-cart').addClass('quick-cart-animate-back')
                      .removeClass('quick-cart-animate') 
      
      setTimeout(function() {
        $('.js-navbar-cart-icon').css({"display": "none"})
      }, 300)
    } else {
      $('js-navbar-cart-icon').css({"display": "block", "width": "0px", "height": "0px", "visibility": "hidden"})
      
      $('.js-quick-cart').removeClass('quick-cart-animate-back')
                      .css("visibility", "visible")
                      .addClass('quick-cart-animate')
    }
      
  })

  $(document).on('focusout', '.js-quick-cart-mobile', function() {
    $('.js-quick-cart').addClass('quick-cart-animate-back')
                    .removeClass('quick-cart-animate') 
  })

  // product animation problem solve
  $('.product-set-item').hover(function() {
    $(this).find('.js-product-set-layer').css("visibility", "visible")
    }, function() {
      $(this).find('.js-product-set-layer').css("visibility", "hidden")
    }
  )

  setTimeout(function() {
    $('.js-recently-item').hover(function() {
      $(this).find('.js-product-set-layer').css("visibility", "visible")
      }, function() {
        $(this).find('.js-product-set-layer').css("visibility", "hidden")
      }
    )
  }, 2000)

  // sorting prices tags in collections/all
  var arr = []
  var arr1 = []
  $('.js-price-tags li').each(function() {
    arr.push(($(this)[0]).innerText.replace('$',''))
    arr1.push(parseInt(($(this)[0]).innerText.replace('$','')))
  })

  arr1.sort(function(a,b) { return a - b })

  $('.js-price-tags').empty()
  while( arr1.length ) {
    for(var j = 0; j < arr.length; j++) {
      if(arr1[0] != undefined && arr[j].includes(arr1[0].toString())) {
          if(window.location.href.includes(arr[j].replace(" ", ""))) {
            $('.js-price-tags').append(`<li class="active"> <a href="/collections/all">${arr[j]} </a></li>`)
          }
          else {
            $('.js-price-tags').append(`<li> <a href="/collections/all/price-${arr[j]}">${arr[j]} </a></li>`)
          }
          arr1.shift()
      }
    }
  }
  $('.cart-curenncies-wrapper').find('select').removeClass('currency-picker white-text')

  //overriden dropdown bootstrap animation
  $(document).on('focusout', '.js-my-dropdown', function() {
    changeHidden($(this).siblings('.dropdown-navbar'))
  })

  $(document).on('focus', '.js-my-dropdown', function(e) {
    dropdownCheck(e)
  })

  // size cart square to fit login in navbar
  var logoHeight = $('#main-header-navbar').height()

  if(window.innerWidth < 996) {
    $('js-quick-cart').css({ top: `${logoHeight/2}px`})
  } else {
    $('.js-navbar-cart-icon').css({height: logoHeight, width: logoHeight})
    $('.js-navbar-cart-icon').find('img').first().css("padding-top",`${logoHeight * 0.45}px`)
    $('js-quick-cart').css({ top: `${logoHeight}px`})  
  }

  //add bootstrap table styling to default shopify tables
  $('table').each(function() {
    $(this).addClass('table')
  })

  $('.product-variant-min-img').on('click', function(e) {
    var srcToShow = $(this).attr('src')
    $('.product-page-image').animate({opacity: "0"}, { duration: 300 })
    setTimeout( function() {
      $('.product-page-image').attr('src',  srcToShow).animate({opacity: "1"}, { duration: 300 })
    }, 200)
  })

  //padding in footer
  // var footColumnPad = $('.footer-logo').height()
  // $('.js-footer-column').each(function() {
  //   $(this).css('padding-top', footColumnPad/2)
  // })

  $('body').on('click', '.js-remove-link', function(e) {
    removeFromCart( $(this) )
  })
})

function dropdownCheck(obj) {
  obj = $(obj.target)
  let visibilityVar = obj.siblings('.dropdown-navbar')
  if ( visibilityVar.css("visibility") == "visible" ) {
    changeHidden(visibilityVar)
  } else { 
    visibilityVar.css({'display': "block", 'opacity': '0.0', 'visibility': 'visible'}).animate({opacity: 1.0}, 200)
  }
}

function changeHidden(visibilityVar) {
  visibilityVar.animate({opacity: 0}, 200)
  setTimeout(function() {
    visibilityVar.css({visibility: "hidden", display: "none"})
  }, 250)
}

function removeFromCart(obj) {
  var mThis = obj
  $.ajax({
    url: '/cart/change.js',
    data: { quantity: 0, line: (mThis.data('line'))},
    dataType: 'json',
    cache: false,
    type: 'post',
    success: function(response) {
      mThis.closest('.quick-cart-item').animate({opacity: 0}, 300, function() {
        if( $('.js-remove-link').length == 1 ) {
          $('js-quick-cart').html('<p class="empty-cart-text">Your cart is empty</p>')
        } else {
          mThis.closest('.quick-cart-item').remove()
        }
        setTimeout(function() {
          $.getJSON('/cart.js', function(cart) {
            
            $('.js-remove-link').each(function(index) {
              $(this).data("line", index+1)
            })

            setTimeout(function(){
              var newCurrency = ''
              if ($('[name="currencies"]').size()) {
                newCurrency = $('[name="currencies"]').val()
              }
              else if ($('#currencies span.selected').size()) {
                newCurrency = $('#currencies span.selected').attr('data-currency')
              }
              let newPrice = '<span class="money">' + Shopify.formatMoney(Currency.convert(cart.total_price, cart.currency, newCurrency), Currency.moneyFormats[newCurrency].money_with_currency_format) + '</span>'
              let itemsCount = cart.item_count
              $('.navbar-right-item').find('.cart-price').html(newPrice)           
              $('.quick-cart-subtotal').find('.cart-price').html(newPrice)     
              $('.items-in-cart').find('.orange-text').html(itemsCount)
              $('#cart-count').html(itemsCount)
            }, 100)
          })
        }, 200)
      })
    },
  })
}

function changeQuantityOfCartProduct(newQuantity, obj) {
  var mThis = obj
  var lineNumber = (mThis.data('line'))
  $.ajax({
    url: '/cart/change.js',
    data: { quantity: newQuantity, line: lineNumber},
    dataType: 'json',
    cache: false,
    type: 'post',
    success: function(response) {
      setTimeout(function() {
        $.getJSON('/cart.js', function(cart) {
          $('.js-remove-link').each(function(index) {
            $(this).data("line", index+1)
          })
          setTimeout(function(){
            var newCurrency = ''
            if ($('[name="currencies"]').size()) {
              newCurrency = $('[name="currencies"]').val()
            }
            else if ($('#currencies span.selected').size()) {
              newCurrency = $('#currencies span.selected').attr('data-currency')
            }
            let newPrice = '<span class="money">' + Shopify.formatMoney(Currency.convert(cart.total_price, cart.currency, newCurrency), Currency.moneyFormats[newCurrency].money_with_currency_format) + '</span>'
            let itemsCount = cart.item_count            
            let newLinePrice = '<span class="money">' + Shopify.formatMoney(Currency.convert(cart.items[lineNumber-1].line_price, cart.currency, newCurrency), Currency.moneyFormats[newCurrency].money_with_currency_format) + '</span>'

            mThis.parents('.quick-cart-item').find('.text-right').html(newLinePrice)
            $('.navbar-right-item').find('.cart-price').html(newPrice)           
            $('.quick-cart-subtotal').find('.cart-price').html(newPrice)     
            $('.items-in-cart').find('.orange-text').html(itemsCount)
            $('#cart-count').html(itemsCount)
          }, 100)
        })
      }, 200)
    },
  })
}
